<template>
  <header>
    <BottomHeader  :is-mobile-view="checkIsMobileView"/>
    <TopHeader  :is-mobile-view="checkIsMobileView"/>
  </header>
</template>

<script>
  import BottomHeader from "./header/BottomHeader";
  import TopHeader from "./header/TopHeader";

  export default {
    name: "AppHeader",
    components: {TopHeader, BottomHeader},
    data () {
      return {
        screenWidth: 0,
      }
    },
    computed: {
      checkIsMobileView() {
        return this.screenWidth < this.$getConst.breakpoints.md;
      }
    },
    created() {
      window.addEventListener('resize', () => {this.screenWidth = window.innerWidth});
      this.screenWidth = window.innerWidth;
    },
    destroyed() {
      window.removeEventListener('resize', () => {this.screenWidth = window.innerWidth});
    }
  }
</script>

<style scoped>

</style>
